'use client';

import Button from '@/components/atoms/button';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';
import AccordionListSB, {
  AccordionListSBProps,
} from '@/components/molecules/accordion/AccordionListSB';

import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';
import { useShowMoreLess } from '@/features/utils/useShowMoreLess';

export interface FAQStrapiProps {
  header?: BlockHeader;
  faqs: AccordionListSBProps;
}

export default function FAQStrapi({
  block,
  ...rest
}: BlockComponentModel<FAQStrapiProps>) {
  const { faqs, header } = block;

  const {
    toggleShowMore,
    initiallyHiddenItems,
    initiallyVisibleItems,
    buttonText,
    showAction,
  } = useShowMoreLess({
    items: faqs.accordionList,
    initialShowCount: 6,
  });

  return (
    <BlockWrapper {...rest} theme={header?.theme?.themeKey}>
      <div
        data-tracker-section={SECTION_NAMES.FAQ}
        itemScope={true}
        itemType='https://schema.org/FAQPage'
      >
        <BlockHeaderContent
          {...header}
          renderButtons={
            showAction
              ? [
                  (props) => (
                    <Button
                      onClick={toggleShowMore}
                      key={buttonText + 'faq-strapi'}
                      {...props}
                      variant='outlined'
                      color='secondary'
                      data-tracker-component='show-more-less'
                    >
                      {buttonText}
                    </Button>
                  ),
                ]
              : undefined
          }
        >
          <AccordionListSB
            block={{ accordionList: initiallyVisibleItems }}
            internal={{ accordionItem: { enableGoogleSchema: true } }}
          />
          <AccordionListSB
            block={{ accordionList: initiallyHiddenItems }}
            internal={{
              accordionItem: { enableGoogleSchema: true },
              ContainerProps: { className: 'hide-content' },
            }}
          />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
